export default __webpack_public_path__ + "static/media/class_x_medical_tab.9e0d6b55.png";